import { tv } from '../../lib/tv';

/**
 * The Figma Checkbox "Box" (Controls ↳ Checkbox, 48:55), keyed on the
 * attributes Radix sets (`data-state`, `data-disabled`) so the same classes
 * style the real Checkbox and the box inside a checkbox Menu Item.
 *
 * Off: 1.5px border/strong inside stroke on bg/surface; hover border/focus.
 * The stroke is an inset box-shadow, not a border: Chromium rounds a 1.5px
 * border down to 1px at 1x density, a shadow keeps the true width.
 * On / Indeterminate: brand/strong (Deep Olive - 3:1 against white, where
 * Primary Green would fail); hover brand/strong-hover; icon/inverse glyph.
 * Focus: the inside stroke is replaced by a 2px border/focus outside stroke.
 * Disabled: bg/disabled + border/default, or bg/emphasis + icon/tertiary.
 */
export const checkboxBox = tv({
  base: [
    'peer inline-flex size-[18px] shrink-0 items-center justify-center rounded-xs',
    'inset-ring-[1.5px] inset-ring-border-strong bg-bg-surface text-icon-inverse outline-none',
    'transition-[background-color,box-shadow] duration-[120ms] ease-out',
    'hover:inset-ring-border-focus',
    'data-[state=checked]:inset-ring-0 data-[state=checked]:bg-brand-strong data-[state=checked]:hover:bg-brand-strong-hover',
    'data-[state=indeterminate]:inset-ring-0 data-[state=indeterminate]:bg-brand-strong data-[state=indeterminate]:hover:bg-brand-strong-hover',
    'focus-visible:inset-ring-0 focus-visible:ring-2 focus-visible:ring-border-focus',
    'data-disabled:inset-ring-border-default data-disabled:bg-bg-disabled data-disabled:text-icon-tertiary',
    'data-disabled:data-[state=checked]:bg-bg-emphasis data-disabled:data-[state=indeterminate]:bg-bg-emphasis',
    'disabled:cursor-not-allowed',
    '[&_svg]:size-3',
  ],
});
